<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('salary') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.salary" :class="{'p-invalid' : submitted && !form.salary }"/>
                        <small class="p-invalid" v-if="submitted && !form.salary"
                            >{{ $t('salary') }} is required.</small
                        >
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('fixed-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="fixed_allowance" mode="decimal" locale="id-ID" v-model="form.fixed_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('transport-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="transport_allowance" mode="decimal" locale="id-ID" v-model="form.transport_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('functional-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="functional_allowance" mode="decimal" locale="id-ID" v-model="form.functional_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('meal-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="meal_allowance" mode="decimal" locale="id-ID" v-model="form.meal_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('special-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="special_allowance" mode="decimal" locale="id-ID" v-model="form.special_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('communication-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="communication_allowance" mode="decimal" locale="id-ID" v-model="form.communcation_allowance"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
export default{
    components:{
        Button, Calendar, Dropdown, InputText, InputNumber,
    },
    props: ['model','submitted'],
    data(){
        return{
            form: this.$page.props.training ?? {
                salary: "",
            },
        }
    },
}
</script>
